module.exports = __webpack_public_path__ + "static/20180910_121121-b7163f8388f41500d8bb201e09b0c973.jpg";